package com.exura.features.plandefinition.data.serialization

import com.exura.features.plandefinition.data.remote.dto.plan.BasePlanDto
import com.exura.features.plandefinition.data.remote.dto.plan.PreparationPlanDto
import com.exura.features.plandefinition.data.remote.dto.plan.TreatmentPlanDto
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic
import kotlinx.serialization.modules.subclass

/**
 * Serializers module specifically for plan-related DTOs
 */
val planSerializersModule = SerializersModule {
    polymorphic(BasePlanDto::class) {
        subclass(PreparationPlanDto::class)
        subclass(TreatmentPlanDto::class)
    }
}
